"use client"; 
import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import { cleanTitle } from '../../utils/helpers';
 const wpUrl = process.env.REACT_APP_WP_URL;
function stripHtml(html) {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
}

const ScheduleOne = () => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isSidebar, setIsSidebar] = useState(false);
  const handleSidebar = (eventData) => {
        setSelectedEvent(eventData);
        setIsSidebar(!isSidebar);
    }
 useEffect(() => {
  const fetchData = async () => {
    try {
      // 1. Fetch events
      const eventsRes = await fetch(`${wpUrl}wp-json/wp/v2/posts?status=publish&_embed`);
      const rawEvents = await eventsRes.json();

      //const sortedEvents = rawEvents.sort((a, b) => new Date(b.event_date) - new Date(a.event_date));
       const sortedEvents = rawEvents
        .filter(event => {
          const terms = event._embedded?.['wp:term']?.[0] || [];
          return !terms.some(cat => cat.slug === 'blog');
        })
        .sort((a, b) => new Date(b.event_date) - new Date(a.event_date));
      const latestFiveEvents = sortedEvents.slice(0, 5);

       
      // 2. Fetch top-level category objects
      const [venueData, genreData, eventtypeData] = await Promise.all([
        fetch(`${wpUrl}wp-json/wp/v2/categories?slug=venue-type`).then(r => r.json()),
        fetch(`${wpUrl}wp-json/wp/v2/categories?slug=genre`).then(r => r.json()),
        fetch(`${wpUrl}wp-json/wp/v2/categories?slug=event-type`).then(r => r.json()),
      ]);

      const venueCat = venueData[0];
      const genreCat = genreData[0];
      const eventtypeCat = eventtypeData[0];

      if (!venueCat && !genreCat && !eventtypeCat) {
        console.warn("No matching parent categories found.");
        return;
      }

      // 3. Fetch all subcategories
            const subcatFetches = [];

            if (venueCat) {
                subcatFetches.push({
                type: 'venue_type',
                promise: fetch(`${wpUrl}wp-json/wp/v2/categories?parent=${venueCat.id}`)
                });
            }

            if (genreCat) {
                subcatFetches.push({
                type: 'genre',
                promise: fetch(`${wpUrl}wp-json/wp/v2/categories?parent=${genreCat.id}`)
                });
            }

            if (eventtypeCat) {
                subcatFetches.push({
                type: 'event_type',
                promise: fetch(`${wpUrl}wp-json/wp/v2/categories?parent=${eventtypeCat.id}`)
                });
            }

            const subcatDataArrays = await Promise.all(
                subcatFetches.map(async obj => ({
                type: obj.type,
                data: await (await obj.promise).json()
                }))
            );

            const allSubcategories = subcatDataArrays.flatMap(obj =>
                obj.data.map(sub => ({ ...sub, type: obj.type }))
            );

            // 4. Attach matched categories to each event
            const eventsWithCategories = latestFiveEvents.map(event => {
                const attachedCategories = event._embedded?.['wp:term']?.[0] || [];

                const matchedSubCategories = attachedCategories
                .map(attached => {
                    const match = allSubcategories.find(sub => sub.id === attached.id);
                    return match ? { ...attached, type: match.type } : null;
                })
                .filter(Boolean);

                //return { ...event, categories: matchedSubCategories };
                // Entry options: only child terms under "entry-options"
                        const entryOptions = attachedCategories.filter(term =>
                            term.link.includes('/category/entry-options/') && term.parent !== 0
                        );

                        return { 
                            ...event, 
                            categories: matchedSubCategories,
                            entry_options: entryOptions // 👈 attach per event
                        };
            });

            setEvents(eventsWithCategories);

            } catch (err) {
            console.error('Error fetching events:', err);
            }
        };

        fetchData();
        }, []);

    return (
         <>
        <section id="th-event" className="schedule-one">
            <div className="container">
                <div className="schedule-one__inner">
                    <div className="section-title text-left">
                        <div className="section-title__tagline-box">
                            <span className="section-title__tagline">Event Schedule</span>
                        </div>
                        <h2 className="section-title__title">Upcoming Events</h2>
                    </div>
                    <div className="schedule-one__main-tab-box tabs-box">
                     
                        <div className="tabs-content">
                            <div className='1st-day' id="1st-day"> 
                                <div className="schedule-one__tab-content-box">
                                {Array.isArray(events) && events.map(event => (
                                    <div className="schedule-one__single" key={event.id}>
                                        <div className="schedule-one__left">
                                        <h4 className="schedule-one__title">
                                            <Link to={`/event-details/${event.slug}`}>
                                            {cleanTitle(event.title.rendered)}
                                            
                                            </Link>
                                        </h4>
                                        <p className="schedule-one__text">
                                        {stripHtml(event.content.rendered).substring(0, 95)}...
                                        
                                        </p>
                                         <div className="event-details__main-tab-box tabs-box">
                                        
                                            <ul className="tab-buttons clearfix list-unstyled">
                                           {event.categories?.map(cat => {
                                            let link = '/event';
                                                if (cat.type === 'venue_type') {
                                                    link += `?venue_type=${encodeURIComponent(cat.slug || '')}`;
                                                } else if (cat.type === 'genre') {
                                                    link += `?genre=${encodeURIComponent(cat.slug || '')}`;
                                                } else if (cat.type === 'event_type') {
                                                    link += `?event_type=${encodeURIComponent(cat.slug || '')}`;
                                                }

                                                return (
                                                    <Link key={cat.id} to={link}>
                                                    <li className="tab-btn">
                                                        <p>{cat.name}</p>
                                                    </li>
                                                    </Link>
                                                );
                                                })}
                                            </ul>
                                        </div>
                                        </div>
                                       
                                        <div className="schedule-one__img">
                                       
                                        <img
                                            src={event._embedded?.['wp:featuredmedia']?.[0]?.source_url}
                                            alt={event.title.rendered}
                                            style={{ width: '100%', height: 'auto' }}
                                            />
                                        </div>
                                        <div className="schedule-one__address-and-btn-box">
                                        <ul className="list-unstyled schedule-one__address">
                                            <li>
                                                <div className="icon">
                                                    <span className="icon-clock"></span>
                                                </div>
                                                <div className="text">
                                                    <p>
                                                    {event.long_date}
                                                    </p>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon">
                                                    <span className="icon-pin"></span>
                                                </div>
                                                <div className="text">
                                                    <p>
                                                    {event.venue}
                                                    </p>
                                                </div>
                                            </li>
                                          {event.promo_code && event.promo_code.trim() !== '' && (
                                            <li>
                                                <div className="icon">
                                                <span className="icon-user"></span>
                                                </div>
                                                <div className="text">
                                                <p>Promo Code: {event.promo_code}</p>
                                                </div>
                                            </li>
                                            )}
                                        </ul>
                                        <div className="schedule-one__btn-box">
                                            <ul className="footer-widget__contact-list list-unstyled">
                                                {event.entry_options?.map((entry_option) => (
                                                <li key={entry_option.id}>
                                                    <div className="icon">
                                                    <span className="icon-star"></span>
                                                    </div>
                                                    <div className="text">
                                                    <Link className='text-white' to={`/event?entry_option=${encodeURIComponent(entry_option.slug || entry_option.name)}`}>
                                                        {entry_option.name}
                                                    </Link><br/>
                                                    {entry_option.name === 'Tickets' && event.ticket_link && (
                                                        <a href={event.ticket_link} target="_blank" rel="noopener noreferrer" className='px-2'>Buy Tickets Here</a>
                                                    )}
                                                    {entry_option.name === 'VIP Tables' && (
                                                        <a onClick={() => handleSidebar(event)}   className='px-2'>Request Table</a>
                                                    )}
                                                    </div>
                                                </li>
                                                ))}
                                                </ul>
                                            
                                        </div>
                                        </div>
                                    </div>
                                    ))}
                                  
                                </div>
                                
                            </div>
                              <div className="blog-one__top">
                                <div className="section-title text-left">
                                </div>
                                <div className="blog-one__btn-box">
                                    <Link to="/event" className="blog-one__btn thm-btn">
                                        View More Events<span className="icon-arrow-right"></span>
                                    </Link>
                                </div>
                                </div>
                                                

                         
                        </div>
                    </div>
                </div>
            </div>
        </section>
          <Sidebar isSidebar={isSidebar} 
            handleSidebar={() => setIsSidebar(false)}
            event={selectedEvent} />
       </>
    );
    
};

export default ScheduleOne;
